import { connect } from "react-redux";
import { Selectors } from "@/store/masterProfile/selectors";
import { Actions } from "@/store/masterProfile/slice";
import FreeSlotsModal from "./";

export default connect(
  (state) => ({
    masterId: Selectors.getMasterId(state),
    isOpen: Selectors.isFreeSlotsOpen(state),
  }),
  (dispatch) => ({
    onClose: () => dispatch(Actions.closeFreeSlots()),
  })
)(FreeSlotsModal);
